import { useEffect, useState } from "react";
import "./yourpackage.css";
import { useParent } from "../../../APIContext/ParentContext";
import { useNewUser } from "../../../APIContext/NewUserContext";
// import { useNavbar } from "../../../APIContext/NavbarContext";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import StaticPageHeaders from "../../../Components/StaticPageHeaders";
import { useSearchParams } from "react-router-dom";
import { useLogin } from "../../../APIContext/LoginContext";

const YourPackage = () => {
  const navigate = useNavigate();

  const { fetchParentPackages } = useParent();
  const { verifyPaymentStatusGuest } = useNewUser();
  const { setUser } = useLogin();
  // const { setGuestVerified  } = useNavbar();
  const [packageData, setPackageData] = useState([]);
  const [loading, setLoading] = useState(true);
  const user = localStorage.getItem("user") || null;
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get("session_id");

  function toUSDate(utcString) {
    const date = new Date(utcString);
    return date.toLocaleDateString("en-US", {
      month: "2-digit",
      day: "2-digit",
      year: "numeric",
    });
  }

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);

      try {
        // GUEST USER
        if (!user) {
          const paymentStatus = await verifyPaymentStatusGuest(sessionId);

          let loggedInUser = paymentStatus.payload?.user;
          if (loggedInUser?.user) {
            loggedInUser = { ...loggedInUser, ...loggedInUser.user };
          }

          localStorage.setItem("user", JSON.stringify(loggedInUser));
          localStorage.setItem("accessToken", paymentStatus.payload?.access);
          localStorage.setItem("refreshToken", paymentStatus.payload?.refresh);

          setUser(loggedInUser);

          const result = await fetchParentPackages();
          if (!result) throw new Error("Failed to fetch packages");

          setPackageData(result);
        }

        // LOGGED-IN USER
        else {
          if (sessionId) {
            const paymentStatus = await verifyPaymentStatusGuest(sessionId);

            if (paymentStatus[0]?.payment?.paid === true) {
              const result = await fetchParentPackages();
              if (!result) throw new Error("Failed to fetch packages");

              setPackageData(result);
            } else {
              // payment not completed
              setPackageData([]);
            }
          } else {
            const result = await fetchParentPackages();
            if (!result) throw new Error("Failed to fetch packages");

            setPackageData(result);
          }
        }
      } catch (error) {
        console.error(error);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Failed to fetch packages.",
          confirmButtonColor: "#f7931a",
          cancelButtonColor: "#1C1C1C",
        });
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  // useEffect(() => {
  //     const fetchData = async () => {
  //          setLoading(true);
  //     if (!user) {

  //         const paymentStatus = await verifyPaymentStatusGuest(sessionId);
  //         // setGuestVerified(true);
  //         let loggedInUser = paymentStatus.payload?.user;
  //         if (loggedInUser?.user) {
  //             loggedInUser = { ...loggedInUser, ...loggedInUser.user };
  //         }

  //         localStorage.setItem("user", JSON.stringify(loggedInUser));
  //         localStorage.setItem("accessToken", paymentStatus.payload?.access);
  //         localStorage.setItem("refreshToken", paymentStatus.payload?.refresh);

  //         setUser(loggedInUser);

  //          const result = await fetchParentPackages();
  //             if (result) {
  //             setPackageData(result);
  //             setLoading(false);
  //             } else {
  //             Swal.fire({
  //                 icon: "error",
  //                 title: "Error",
  //                 text: "Failed to fetch packages.",
  //                 confirmButtonColor: "#f7931a",
  //                 cancelButtonColor: "#1C1C1C",
  //             });
  //             }
  //     }else{
  //         if(sessionId){
  //             const paymentStatus = await verifyPaymentStatusGuest(sessionId);
  //             // console.log(paymentStatus);

  //             if (paymentStatus[0]?.payment?.paid === true) {

  //                 const result = await fetchParentPackages();
  //                 if (result) {
  //                 setPackageData(result);
  //                 setLoading(false);
  //                 } else {
  //                 Swal.fire({
  //                     icon: "error",
  //                     title: "Error",
  //                     text: "Failed to fetch packages.",
  //                     confirmButtonColor: "#f7931a",
  //                     cancelButtonColor: "#1C1C1C",
  //                 });
  //                 }
  //             }
  //         }else{

  //             const result = await fetchParentPackages();
  //             if (result) {
  //               setPackageData(result);
  //               setLoading(false);
  //             } else {
  //               Swal.fire({
  //                 icon: "error",
  //                 title: "Error",
  //                 text: "Failed to fetch packages.",
  //                 confirmButtonColor: "#f7931a",
  //                 cancelButtonColor: "#1C1C1C",
  //               });
  //             }
  //         }

  //     }
  //     };

  //     fetchData();
  //   }, []);

  const handleBookSession = (sport_id, sale_id, is_unlimited) => {
    navigate(
      `/schedule-your-sessions?sport_id=${sport_id}&sale_id=${sale_id}&is_unlimited=${is_unlimited}`,
    );
  };

  return (
    <>
      <StaticPageHeaders title="Your Package" />
      <div className="your-package-page bg-custom brightness">
        <table>
          <thead>
            <tr>
              <th className="text-clip">Package Name</th>
              <th className="text-clip">Player </th>
              <th className="text-clip">Purchased</th>
              <th className="text-clip">Remaining Sessions</th>
              <th className="text-clip">Type</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td className="text-clip" colSpan={6} style={{ textAlign: "center" }}>
                  Loading packages...
                </td>
              </tr>
            ) : packageData?.length > 0 ? (
              packageData.map((item, index) => (
                <tr key={index}>
                  <td className="text-clip">
                    <span className="lable-table">Package Name :</span>
                    {item.package?.name}
                  </td>
                  <td className="text-clip">
                    <span className="lable-table">Player Name :</span>
                    {item.player?.name}
                  </td>
                  <td className="text-clip">
                    <span className="lable-table">Purchased :</span>
                    {toUSDate(item.start_date)}
                  </td>
                  <td className="text-clip">
                    <span className="lable-table">Remaining Sessions :</span>
                    {item.is_unlimited ? "Unlimited" : item.remaining_sessions}
                  </td>
                  <td className="text-clip">
                    <span className="lable-table">Type :</span>
                    {item.package?.is_group_session ? "Group" : "One on One"}
                  </td>
                  <td className="action-td">
                    <button
                      className="btn-primary-outline btn-sm"
                      onClick={() =>
                        handleBookSession(
                          item.package?.sports,
                          item.id,
                          item.is_unlimited,
                        )
                      }
                    >
                      Book a Session
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={6} style={{ textAlign: "center" }}>
                  <span className="text-clip">Packages Not found!</span>
                  <br />
                  <button
                    style={{ filter: "brightness(0.86)" }}
                    className="btn-primary-outline btn-sm"
                    onClick={() => navigate("/")}
                  >
                    Back to Home
                  </button>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </>
  );
};
export default YourPackage;
